import RouterSection from '@/Layout/components/RouterSection'

export default {
  path: '/estimate',
  name: 'estimate_home',
  component: RouterSection,
  mode: 'history',
  children: [
    /* 온라인 견적서 목록 */
    {
      path: 'list',
      name: 'estimatelist',
      component: () => import('@/views/estimate/EstimateList.vue')
    },
    /* 견적서 관리 */
    {
      path: 'manage',
      name: 'estimatemanagement',
      component: () => import('@/views/estimate/EstimateManagement.vue')
    },
  ]
}